import {BackendApi} from '@/services/backend_api'

export default {
  get (id) {
    return BackendApi.getAnonymousClient().get(`companies/${id}`)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  cget () {
    return BackendApi.getAnonymousClient().get(`companies/`)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  cgetByPark (parkId) {
    return BackendApi.getAnonymousClient().get(`parks/${parkId}/companies/`)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  post (parkId, company) {
    return BackendApi.getClient().post(`parks/${parkId}/companies/`, company)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  put (company) {
    return BackendApi.getClient().put(`/companies/${company.id}`, company)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  unlink (companyId, date) {
    return BackendApi.getClient().post(`companies/${companyId}/unlink`, { date })
    .then(response => { return response })
    .catch(e => { throw e })
  },
  relink (companyId, date) {
    return BackendApi.getClient().post(`companies/${companyId}/relink`, { date })
    .then(response => { return response })
    .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/company.js